import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/site/Reveal";
import { useLang } from "@/i18n/LanguageContext";
import { LEGAL_CONTENT } from "@/data/legal";
import { usePageMeta } from "@/lib/usePageMeta";

export default function LegalPage({ kind }) {
    usePageMeta(
        kind === "mentions" ? { fr: "Mentions légales — WEYB", en: "Legal notice — WEYB" } : { fr: "Politique de confidentialité — WEYB", en: "Privacy policy — WEYB" },
        kind === "mentions"
            ? { fr: "Mentions légales de WEYB : éditeur du site, hébergement, propriété intellectuelle et protection des données personnelles.", en: "WEYB legal notice: site publisher, hosting, intellectual property and personal data protection." }
            : { fr: "Politique de confidentialité de WEYB : données collectées via le formulaire de contact, finalités, mesure d'audience avec consentement et droits RGPD.", en: "WEYB privacy policy: data collected via the contact form, purposes, consent-based analytics and your GDPR rights." }
    );
    const { lang, prefix } = useLang();
    const page = LEGAL_CONTENT[lang][kind];

    return (
        <section data-testid={`legal-${kind}`} className="bg-white pt-32 md:pt-40 pb-24 md:pb-32 min-h-screen">
            <div className="max-w-3xl mx-auto px-6">
                <Eyebrow index="WEYB">{page.eyebrow}</Eyebrow>
                <Reveal>
                    <h1 className="font-display text-4xl md:text-5xl font-light tracking-tight text-weyb-ink leading-tight">
                        {page.title}
                    </h1>
                </Reveal>
                <Reveal delay={0.08}>
                    <p className="mt-4 text-sm text-gray-400">{page.updated}</p>
                </Reveal>

                <div className="mt-12 space-y-10">
                    {page.sections.map((s, i) => (
                        <Reveal key={s.heading} delay={i * 0.04}>
                            <div data-testid={`legal-section-${i}`}>
                                <h2 className="font-display text-xl font-medium text-weyb-ink">{s.heading}</h2>
                                <div className="mt-3 space-y-3">
                                    {s.paragraphs.map((p, j) => (
                                        <p
                                            key={j}
                                            className={`text-sm leading-relaxed ${
                                                p.startsWith("[")
                                                    ? "text-weyb-yellow-dark font-medium border-l-2 border-weyb-yellow pl-4"
                                                    : "text-gray-600"
                                            }`}
                                        >
                                            {p}
                                        </p>
                                    ))}
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.1}>
                    <Link
                        to={prefix || "/"}
                        data-testid="legal-back-home"
                        className="mt-14 inline-flex items-center gap-2 text-sm font-semibold text-weyb-ink hover:text-weyb-yellow-dark transition-colors"
                    >
                        <ArrowLeft size={15} />
                        {page.back}
                    </Link>
                </Reveal>
            </div>
        </section>
    );
}
